import { useEffect, useState, useRef } from 'react';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { AddH1TagsView } from './AddH1TagsView';
import { replaceSingleH1TagWithH2Tag } from './addH1TagsUtils';
import { useTracker } from '../../../context/hooks';
import { AutoFixButton } from './AutoFixButton';
import { H1AutoFixList } from './H1AutoFixList';
import { H1TextContent } from './H1TextContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MessageOrAutoFixButton = ({
  h1IsInPageTitle,
  h1IsInPostBody,
  updateBlogPostBody
}) => {
  if (h1IsInPageTitle) {
    return /*#__PURE__*/_jsx("i", {
      children: "in page title"
    });
  }
  if (!h1IsInPostBody) {
    return null;
  }
  return /*#__PURE__*/_jsx(AutoFixButton, {
    onClick: updateBlogPostBody
  });
};
const BlogH1AutoFixList = ({
  h1Elements,
  pageTitle,
  postBody,
  updateBlogPostBody
}) => {
  const {
    track
  } = useTracker();
  const [showLoader, toggleShowLoader] = useState(false);
  const previousH1Elements = useRef(h1Elements);
  useEffect(() => {
    if (showLoader && previousH1Elements.current !== h1Elements) {
      toggleShowLoader(false);
    }
    previousH1Elements.current = h1Elements;
  }, [showLoader, previousH1Elements, h1Elements]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "h1-auto-fix-list",
    style: {
      position: 'relative'
    },
    children: [showLoader && /*#__PURE__*/_jsx(UILoadingOverlay, {
      contextual: true
    }), /*#__PURE__*/_jsx(H1AutoFixList, {
      listItems: h1Elements.map((h1, i) => /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx(H1TextContent, {
          textContent: h1.textContent
        }), h1.textContent !== '' && pageTitle && postBody && /*#__PURE__*/_jsx(MessageOrAutoFixButton, {
          h1IsInPageTitle: pageTitle === h1.textContent,
          h1IsInPostBody: postBody.includes(h1.innerHTML),
          updateBlogPostBody: () => {
            updateBlogPostBody(postBody, h1.innerHTML);
            toggleShowLoader(true);
            track('clickedFixLink', {
              recommendationType: 'FIX_H1_TAGS'
            });
          }
        })]
      }, i))
    })]
  });
};
export const FixH1TagsBlogView = ({
  auditResult,
  editorApi
}) => {
  const {
    updateBlogPostBody
  } = editorApi;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(AddH1TagsView, {
      auditResult: auditResult,
      autofixList: auditResult.h1Elements && auditResult.h1Elements.length > 1 && /*#__PURE__*/_jsx(BlogH1AutoFixList, {
        h1Elements: auditResult.h1Elements,
        pageTitle: auditResult.pageTitle,
        postBody: auditResult.postBody,
        updateBlogPostBody: (postBody, innerHTML) => updateBlogPostBody(replaceSingleH1TagWithH2Tag(postBody, innerHTML))
      })
    })
  });
};